import React, { useState, useEffect } from "react";
import ColorFieldComponent from "../../../Components/Forms/ColorFieldComponent";
import { ConeConfiguracao } from "../../../Models/Paineis/ConeDeRisco/ConeConfiguracao";
import { ReactComponent as Cone } from "../../../Svgs/cone.svg";

const ConeConfiguracaoCentralTab = (props: any) => {
    const [coneConfiguracao, setConeConfiguracao] = useState<any>(new ConeConfiguracao());

    useEffect(() => {
        setConeConfiguracao(props.coneConfiguracao);
    }, [props.coneConfiguracao]);

    const teste = 10;

    return (
        <div className="container">
            <div className="row" style={{ backgroundColor: '#888', paddingTop: '10px', paddingBottom: '0px', marginBottom: '0px' }}>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Camada 1"
                        field='cor_camada_1'
                        id='cor_camada_1'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Interna 1"
                        field='cor_interna_1_camada_1'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Interna 2"
                        field='cor_interna_2_camada_1'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Interna 3"
                        field='cor_interna_3_camada_1'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Fundo Círculo"
                        field='fundo_circulo_camada_1'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Fonte"
                        field='cor_fonte_camada_1'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
            </div>

            <div className="row" style={{paddingTop: '10px', marginBottom: '0px', paddingBottom: '10px'}}>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Camada 2"
                        field='cor_camada_2'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Interna 1"
                        field='cor_interna_1_camada_2'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Interna 2"
                        field='cor_interna_2_camada_2'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Interna 3"
                        field='cor_interna_3_camada_2'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Fundo Círculo"
                        field='fundo_circulo_camada_2'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Fonte"
                        field='cor_fonte_camada_2'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
            </div> 

            <div className="row" style={{ backgroundColor: '#888', paddingTop: '10px', paddingBottom: '0px', marginBottom: '0px' }}>
            
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Camada 3"
                        field='cor_camada_3'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Interna 1"
                        field='cor_interna_1_camada_3'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Interna 2"
                        field='cor_interna_2_camada_3'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Interna 3"
                        field='cor_interna_3_camada_3'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Fundo Círculo"
                        field='fundo_circulo_camada_3'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Fonte"
                        field='cor_fonte_camada_3'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
            </div>

            <div className="row" style={{paddingTop: '10px', marginBottom: '0px', paddingBottom: '10px'}}>
            
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Camada 4"
                        field='cor_camada_4'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Interna 1"
                        field='cor_interna_1_camada_4'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Interna 2"
                        field='cor_interna_2_camada_4'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Interna 3"
                        field='cor_interna_3_camada_4'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Fundo Círculo"
                        field='fundo_circulo_camada_4'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Fonte"
                        field='cor_fonte_camada_4'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
            </div>

            <div className="row" style={{ backgroundColor: '#888', paddingTop: '10px', paddingBottom: '0px', marginBottom: '0px' }}>
            
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Camada 5"
                        field='cor_camada_5'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Interna 1"
                        field='cor_interna_1_camada_5'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Interna 2"
                        field='cor_interna_2_camada_5'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Interna 3"
                        field='cor_interna_3_camada_5'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Fundo Círculo"
                        field='fundo_circulo_camada_5'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Fonte"
                        field='cor_fonte_camada_5'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
            </div>

            <div className="row" style={{paddingTop: '10px', marginBottom: '0px', paddingBottom: '10px'}}>
            
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Camada 6"
                        field='cor_camada_6'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Interna 1"
                        field='cor_interna_1_camada_6'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Interna 2"
                        field='cor_interna_2_camada_6'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Interna 3"
                        field='cor_interna_3_camada_6'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Fonte"
                        field='cor_fonte_camada_6'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
            </div>
            
            <div className="row" style={{ backgroundColor: '#888', paddingTop: '10px', paddingBottom: '0px', marginBottom: '0px' }}>
            
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Camada 7"
                        field='cor_camada_7'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Interna 1"
                        field='cor_interna_1_camada_7'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Interna 2"
                        field='cor_interna_2_camada_7'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
                <div className="col-md-2">
                    <ColorFieldComponent
                        label="Cor Fonte"
                        field='cor_fonte_camada_7'
                        model={coneConfiguracao}
                        colorChangedCallback={props.colorChangedCallback}  
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-md-6 mb-6">
                    <Cone />
                </div>
            </div>
        </div>
    );
}

export default ConeConfiguracaoCentralTab;